// extracted by mini-css-extract-plugin
export default {"text":"comment-cell_text__5dvYE"};